import { render, staticRenderFns } from "./EditExtension.vue?vue&type=template&id=72d4cc19&"
import script from "./EditExtension.vue?vue&type=script&lang=js&"
export * from "./EditExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports